import { render, staticRenderFns } from "./OrderItemForm.vue?vue&type=template&id=1edd8530"
import script from "./OrderItemForm.vue?vue&type=script&lang=js"
export * from "./OrderItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports